import React from 'react'
import PropTypes from 'prop-types'

import S from '../Loading.styled'

const Text = ({ className }) => {
  return <S.Text className={className}></S.Text>
}

Text.propTypes = {
  className: PropTypes.string,
}

export default Text
